module.exports = "<symbol id=\"tt-icon-check\" viewBox=\"0 0 24 24\"><path d=\"M7.47 21.98L.14 14.65l2.63-2.63 4.57 4.58L20.92 1.67l2.75 2.5-16.2 17.81z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"


//////////////////
// WEBPACK FOOTER
// ./src/build/VuTUYdwvqIExdDFsite/assets/svg/non-defined-page/check.svg
// module id = 161
// module chunks = 11